<div *ngIf="showMenu">
  <nav id="field-content " class="field-content">
    <ion-grid>
      <ion-row>
        <ion-col>CAMPOS</ion-col>
        <ion-col (click)="closeMenu()">
          <span class="close-button">X</span>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div class="list-container">
      <div class="item" *ngFor="let field of fields">
        <ion-label>{{ field.label }}</ion-label>
        <ion-fab-button
          color="secondary"
          size="small"
          (click)="
            setCenterMap(
              field.coordinates.latitude,
              field.coordinates.longitude
            ); 
            fieldSelected = field.id
          "
        >
          <ion-icon [name]="fieldSelected == field.id ? 'location'  : 'locate'"></ion-icon>
        </ion-fab-button>
      </div>
    </div>
  </nav>
</div>
